import { render } from "./ak_setting.vue?vue&type=template&id=5b4c2786&scoped=true"
import script from "./ak_setting.vue?vue&type=script&lang=js"
export * from "./ak_setting.vue?vue&type=script&lang=js"

import "./ak_setting.vue?vue&type=style&index=0&id=5b4c2786&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4c2786"]])

export default __exports__